module.exports = __webpack_public_path__ + "img/trap-yellow.dec751b5.png";